// extracted by mini-css-extract-plugin
export default {"wrapper":"_C-z","button":"aD-z","alternate":"bD-z","disabled":"cD-z","paymentWarning":"dD-z","fadeIn":"eD-z"};